import classnames from "classnames";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody, CardText } from "reactstrap";
import { useTranslation } from "react-i18next";
import { MdDescription } from "react-icons/md";
import { MdRadio } from "react-icons/md";
import { VscSymbolClass } from "react-icons/vsc";
import { FaLanguage } from "react-icons/fa";
import { BsFillTagsFill } from "react-icons/bs";
import { MdOutlineCategory } from "react-icons/md";
import { GiSandsOfTime } from "react-icons//gi";
import { HiPuzzle } from "react-icons/hi";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { FaEye } from "react-icons/fa";
import { secondsToTime } from "@store/action/GlobalAction";

const EmissionsCards = (props) => {
  const { datas, activeView } = props;
  const { t } = useTranslation();
  const shareUrl = window.location.origin;

  const renderdata = () => {
    if (datas?.length) {
      return datas?.map((item, i) => (
        <Card
          className="ecommerce-card"
          key={i}
          style={{
            gridTemplateColumns: "2fr 2fr 1fr",
          }}
        >
          <div className="item-img text-center mx-auto">
            <Link to={`/emission/${item.id}`}>
              <img
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
                className="img-fluid card-img-top"
                src={item.picture}
                alt={item.name}
              />
            </Link>
          </div>
          <CardBody>
            <h6 style={{ marginBottom: "15px" }} className="item-name">
              <Link to={`/emission/${item.id}`}>
                <MdRadio size={25} /> {item.name}
              </Link>
            </h6>
            {item?.description && (
              <CardText className="item-description" tag="div">
                <p>
                  <MdDescription />
                  {t("Description :")} {item.description}
                </p>
              </CardText>
            )}
            {item?.categorie?.name && (
              <CardText className="item-description" tag="div">
                <p>
                  {t("Category")} : {item.categorie?.name}
                </p>
              </CardText>
            )}
            {item?.language?.name && (
              <CardText className="item-description" tag="div">
                <p>
                  <FaLanguage /> {t("Language")} : {item?.language.name}
                </p>
              </CardText>
            )}
            {item?.classification?.name && (
              <CardText className="item-description" tag="div">
                <p>
                  <VscSymbolClass /> {t("Classification :")}
                  <Link
                    to={`/emissions/classification/${item.classification?.id}`}
                  >
                    {item.classification?.name}
                  </Link>
                </p>
              </CardText>
            )}
            {item.tags.length > 0 ? (
              <CardText className="item-description" tag="div">
                <p>
                  <BsFillTagsFill /> {t("Tags :")}
                  {item?.tags?.map((el, i) => (
                    <Link key={i} to={`/emissions/tag/${el.slug}`}>
                      <Badge className="ms-1" color="light-secondary" pill>
                        {el?.name}
                      </Badge>
                    </Link>
                  ))}
                </p>
              </CardText>
            ) : (
              <></>
            )}
            {item?.categories?.length > 0 && (
              <CardText className="item-description" tag="div">
                <p>
                  <MdOutlineCategory /> {t("categories")} :
                  {item?.categories?.map((el, i) => (
                    <Link key={i} to={`/emissions/category/${el.slug}`}>
                      <Badge className="ms-1" color="light-warning" pill>
                        {el.name}
                      </Badge>
                    </Link>
                  ))}
                </p>
              </CardText>
            )}
            {item.max_duration_sec && (
              <CardText className="item-description" tag="div">
                <p>
                  <GiSandsOfTime /> {t("Max duration")} :
                  {secondsToTime(item.max_duration_sec)}
                </p>
              </CardText>
            )}
            {item?.episodes?.length > 0 && (
              <CardText className="item-description" tag="div">
                <p>
                  <HiPuzzle /> {t("episodes")} : {item?.episodes?.length}
                </p>
              </CardText>
            )}
            <div className="item-cost">
              <h6 className="item-price">
                <CardText tag="div">
                  <ul
                    className="blog-icon-podcast"
                    style={{ textAlign: "center" }}
                  >
                    <li>
                      <FacebookShareButton
                        url={`${shareUrl}/emission/${item.id}`}
                      >
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>

                    <li>
                      <TwitterShareButton
                        url={`${shareUrl}/emission/${item.id}`}
                      >
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton
                        url={`${shareUrl}/emission/${item.id}`}
                      >
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton
                        url={`${shareUrl}/emission/${item.id}`}
                      >
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                  </ul>
                </CardText>
              </h6>
            </div>
          </CardBody>
          <div className="item-options text-center">
            <h4 className="item-price">
              <div
                className="text-center mx-auto cursor-pointer me-50 py-50"
                style={{ flexDirection: "row" }}
              >
                <Link
                  to={`/emission/${item.id}`}
                  style={{ marginRight: "5px" }}
                >
                  <FaEye
                    style={{ display: "inline !important" }}
                    size={20}
                    id="Show"
                  />
                </Link>
              </div>
              <CardText tag="div">
                <ul
                  className="blog-icon-podcast"
                  style={{ textAlign: "center" }}
                >
                  <li>
                    <FacebookShareButton
                      url={`${shareUrl}/emission/${item.id}`}
                    >
                      <FacebookIcon size={30} round={true} />
                    </FacebookShareButton>
                  </li>
                  <li>
                    <TwitterShareButton url={`${shareUrl}/emission/${item.id}`}>
                      <TwitterIcon size={30} round={true} />
                    </TwitterShareButton>
                  </li>
                  <li>
                    <WhatsappShareButton
                      url={`${shareUrl}/emission/${item.id}`}
                    >
                      <WhatsappIcon size={30} round={true} />
                    </WhatsappShareButton>
                  </li>
                  <li>
                    <FacebookMessengerShareButton
                      url={`${shareUrl}/emission/${item.id}`}
                    >
                      <FacebookMessengerIcon size={30} round={true} />
                    </FacebookMessengerShareButton>
                  </li>
                </ul>
              </CardText>
            </h4>
          </div>
        </Card>
      ));
    }
  };

  return (
    <div
      className={classnames({
        "grid-view": activeView === "grid",
        "list-view": activeView === "list",
      })}
    >
      {renderdata()}
    </div>
  );
};

export default EmissionsCards;
